import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Orders from "./pages/Orders";
import Cart from "./pages/Cart";
import Network from "./pages/Network";
import Wallet from "./pages/Wallet";
import Commissions from "./pages/Commissions";
import Notifications from "./pages/Notifications";
import ProtectedRoute from "./ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AdminLogin from "./admin/Login";
import ProtectedRouteAdmin from "./ProtectedRouteAdmin";
import AdminDashboard from "./admin/Dashboard";
import AdminProducts from "./admin/Products";
import AdminPaymentHistory from "./admin/AdminPaymentHistory";
import AdminWalletTransactions from "./admin/AdminWalletTransactions";
import AdminRefferalTree from "./admin/AdminRefferalTree";
import AdminCommissionsLedger from "./admin/AdminCommissionsLedger";
import AdminDeliveries from "./admin/AdminDeliveries";
import Settings from "./pages/Settings";
import Home from "./pages/Home";
import Terms from "./pages/Terms";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer position="bottom-center" autoClose={1000} />
      <Routes>
        {/* USER ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <Products />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          }
        />
        <Route
          path="/network"
          element={
            <ProtectedRoute>
              <Network />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet"
          element={
            <ProtectedRoute>
              <Wallet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commissions"
          element={
            <ProtectedRoute>
              <Commissions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Notifications />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />

        {/* ADMIN ROUTES */}
        <Route path="/manage" element={<AdminLogin />} />
        <Route path="/manage/login" element={<AdminLogin />} />

        <Route
          path="/manage/dashboard"
          element={
            <ProtectedRouteAdmin>
              <AdminDashboard />
            </ProtectedRouteAdmin>
          }
        />

        <Route
          path="/manage/products"
          element={
            <ProtectedRouteAdmin>
              <AdminProducts />
            </ProtectedRouteAdmin>
          }
        />

        <Route
          path="/manage/payments"
          element={
            <ProtectedRouteAdmin>
              <AdminPaymentHistory />
            </ProtectedRouteAdmin>
          }
        />

        <Route
          path="/manage/wallet-transactions"
          element={
            <ProtectedRouteAdmin>
              <AdminWalletTransactions />
            </ProtectedRouteAdmin>
          }
        />

        <Route
          path="/manage/refferal-tree"
          element={
            <ProtectedRouteAdmin>
              <AdminRefferalTree />
            </ProtectedRouteAdmin>
          }
        />

        <Route
          path="/manage/commissions-ledger"
          element={
            <ProtectedRouteAdmin>
              <AdminCommissionsLedger />
            </ProtectedRouteAdmin>
          }
        />

        <Route
          path="/manage/deliveries"
          element={
            <ProtectedRouteAdmin>
              <AdminDeliveries />
            </ProtectedRouteAdmin>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
